<template>
    <div class="text">
        <vue-markdown :key="updates">
            {{ text }}
        </vue-markdown>
    </div>
</template>

<style scoped>
.text {
    color: white;
}
</style>

<script>
import VueMarkdown from 'vue-markdown';

export default {
    name: "GeneralText33",
    niceName: "General Text 3x3",
    width: 3,
    height: 3,
    description: "A text area you can write instructions or whatever you want in it.",
    
    options: {
        text: {
            name: 'Text',
            type: 'textarea',
            placeholder: "My Markdown",
        },
    },
    components: {
        VueMarkdown,
    },
    props: {
        text: {
            type: String,
            default: "No Text",
        },
    },
    data() {
        return {
            updates: 0,
        };
    },
    watch: {
        text(newval, oldval){
            this.updates += 1;
        },
    },

};
</script>
